import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface SegmentedOption {
    value: string | number | boolean;
    label: string;
    disabled?: boolean;
}

export type SegmentedOptionGroupSize = 'small' | 'medium';
export type SegmentedOptionGroupLayout = 'inline' | 'wrap';

@Component({
    selector: 'app-segmented-option-group',
    templateUrl: './segmented-option-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SegmentedOptionGroupComponent {
    @Input() options: SegmentedOption[] = [];
    @Input() value: string | number | boolean | null = null;
    @Input() disabled = false;
    @Input() size: SegmentedOptionGroupSize = 'medium';
    @Input() layout: SegmentedOptionGroupLayout = 'inline';
    @Input() translateLabels = false;

    @Output() valueChange = new EventEmitter<string | number | boolean>();

    get wrapperClass(): string {
        return this.layout === 'wrap'
            ? 'flex flex-wrap gap-1.5'
            : 'inline-flex flex-wrap gap-1 rounded-md border border-white/50 bg-white/35 p-1';
    }

    get buttonClass(): string {
        return this.size === 'small'
            ? 'rounded-sm border px-2.5 py-1.5 text-xs'
            : 'h-9 rounded-sm px-3 text-sm';
    }

    select(option: SegmentedOption): void {
        if (this.disabled || option.disabled) {
            return;
        }

        this.valueChange.emit(option.value);
    }

    isSelected(option: SegmentedOption): boolean {
        return this.value === option.value;
    }

    isDisabled(option: SegmentedOption): boolean {
        return this.disabled || option.disabled === true;
    }

    trackByValue(_: number, option: SegmentedOption): string {
        return String(option.value);
    }
}
